import moment from 'moment';
import * as XLSX from 'xlsx';
import { Barcode } from 'constants/enums';

export const getDollarFormat = (value = 0) => value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
export const getNumberFormat = (value = 0) => value.toLocaleString('en-US');
export const convertDateToString = (value) => new Date(value).toISOString().slice(0, 10);
export const splitWords = (value) => value.replace(/([a-z](?=[A-Z]))/g, '$1 ');
export const stringToDecimalFormatter = (value) => parseFloat(value).toFixed(2);
export const formatNumbers = (value, format) => {
    switch (format) {
        case "$":
            return getDollarFormat(value)
        case "%":
            return `${value}%`
        default:
            return `${value}`
    }
}

export const validateTableComponents = (event, product) => {
    let p = Math.max(0, parseFloat(event.target.value)).toString().slice(0, 7);
    if (p <= product.quantity) {
        event.target.value = p;
    } else if (p > product.quantity) {
        event.target.value = product.quantity;
    } else {
        event.target.value = p;
    }
}

export const validateMaxInTextInput = (event, max) => {
    let p = Math.max(0, parseFloat(event.target.value)).toString().slice(0, 7);
    if (p <= max) {
        event.target.value = p;
    } else if (p > max) {
        event.target.value = max;
    } else {
        event.target.value = p;
    }
}

export const timeConverter = (value) => {
    let hours = (value / 60);
    let h = Math.floor(hours);
    let minutes = (hours - h) * 60;
    let m = Math.round(minutes);

    return h + " hrs " + m + " mins";
}

export const colorCategory = (value) => {

    const driedCann = "#876D00";
    const solidCon = "#F79941";
    const nonSolidCon = "#4A426B";
    const freshCann = "#68AE32";
    const solidCann = "#1D8FED";
    const nonSolidCann = "#890068";
    const seedCann = "#04670B";
    const uncategorized = "#4A426B";

    switch (value) {
        //dark greenish blue
        case "non-solids containing cannabis":
            return nonSolidCann;

        //light purple
        case "solids containing cannabis":
            return solidCann;

        //light green
        case "fresh cannabis":
            return freshCann;

        //greenish brown
        case "dried cannabis":
            return driedCann;

        //orange
        case "cannabis solid concentrates":
            return solidCon;

        //dark purple
        case "cannabis non-solid concentrates":
            return nonSolidCon;

        //dark green
        case "cannabis plant seeds":
            return seedCann;

        //Uncategorized
        default:
            return uncategorized;
    }


}

export const checkDateRange = (beginDate, endDate) => {
    return moment(beginDate).isAfter(endDate)
}


export const roundToDecimalPlace = (number, decimalPlace) => {
    return Math.round(number * 10 ** decimalPlace) / 10 ** decimalPlace
}

export const generateRanges = ({ thC_LEVEL, cbD_LEVEL, thC_MIN, thC_MAX, cbD_MIN, cbD_MAX, unitOfMeasurement }) => {
    const units = {
        0: '%',
        1: '%',
        2: 'mg/ea',
        3: 'mg/cap',
        4: 'mg/ml',
        5: 'mg/unit',
        6: 'mg/pack',
        7: 'mg/spray',
        8: 'mg/bottle',
        9: 'mg/g',
        10: 'mg'
    };
    const unit = units[unitOfMeasurement] || '';

    return {
        cbdLabel: cbD_LEVEL ? `${cbD_LEVEL} ${unit}` : cbD_MIN >= 0 && cbD_MAX ? `${cbD_MIN} ~ ${cbD_MAX} ${unit}` : 'n/a',
        thcLabel: thC_LEVEL ? `${thC_LEVEL} ${unit}` : thC_MIN >= 0 && thC_MAX ? `${thC_MIN} ~ ${thC_MAX} ${unit}` : 'n/a'
    };
};

export const getPriceToShow = (isMember, oneProduct, eliteMemberEndDate, isEmployee, isHighTide, isInspired) => {
    let item = oneProduct;

    if (isEmployee && (isHighTide || isInspired)) {
        let memberIsEmployeeMultiplier = 2;
        if (isHighTide) {
            memberIsEmployeeMultiplier = 1.1;
        }
        if (isInspired) {
            memberIsEmployeeMultiplier = 1.15;
        }
        if (item.isCannabis && item.packages && item.packages.length === 1) {
            return item.packages[0].baseCost * memberIsEmployeeMultiplier;
        }
    }

    if (oneProduct.isElite) {
        if (item.memberUnitPrice > 0 && item.memberUnitPrice < 999) {
            if (isMember && eliteMemberEndDate && eliteMemberEndDate > moment().format('YYYY-MM-DD')) {
                return Math.min(item.unitPrice, item.promotionUnitPrice, item.memberUnitPrice, item.eliteMemberUnitPrice);
            } else if (isMember) {
                return Math.min(item.unitPrice, item.promotionUnitPrice, item.memberUnitPrice);
            } else {
                return Math.min(item.unitPrice, item.promotionUnitPrice);
            }
        } else {
            return Math.min(item.unitPrice, item.promotionUnitPrice, item.eliteMemberUnitPrice);
        }
    } else {
        if (isMember) {
            return Math.min(item.unitPrice, item.promotionUnitPrice, item.memberUnitPrice);
        } else {
            return Math.min(item.unitPrice, item.promotionUnitPrice);
        }
    }
}

export const numDaysBetween = (d1, d2) => {
    var diff = Math.abs(d1.getTime() - d2.getTime());
    return diff / (1000 * 60 * 60 * 24);
}

export const readSKUMappingExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);

        fileReader.onload = (e) => {
            const bufferArray = e.target.result;

            const wb = XLSX.read(bufferArray, { type: "buffer" });

            const wsname = wb.SheetNames[0];

            const ws = wb.Sheets[wsname];

            const data = XLSX.utils.sheet_to_json(ws);

            let model = {
                wsname,
                data
            }
            resolve(model);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
    });

    promise.then((d) => {
        return d;
    });

    return promise;
};

export const readPOExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);

        fileReader.onload = (e) => {
            const bufferArray = e.target.result;

            const wb = XLSX.read(bufferArray, { type: "buffer" });

            const wsname = wb.SheetNames[0];

            const ws = wb.Sheets[wsname];

            const data = XLSX.utils.sheet_to_json(ws);

            console.log(data);
            resolve(data);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
    });

    promise.then((d) => {
        return d;
    });

    return promise;
};

export const readExcel = (file) => {
    const promise = new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsArrayBuffer(file);

        fileReader.onload = (e) => {
            const bufferArray = e.target.result;

            const wb = XLSX.read(bufferArray, { type: "buffer" });

            const wsname = wb.SheetNames[0];

            const ws = wb.Sheets[wsname];

            const data = XLSX.utils.sheet_to_json(ws);

            console.log(data);
            resolve(data);
        };

        fileReader.onerror = (error) => {
            reject(error);
        };
    });

    promise.then((d) => {
        return d;
    });

    return promise;
};

export const getBarcodeType = (barcode) => {
    if (barcode[0] == 'Z') {
        return Barcode.Product;

    } else if (barcode[0] == 'C') {
        return Barcode.Combo;

    } else if (barcode.length >= 25 && barcode.substring(0, 2) === "01" && (barcode.substring(16, 18) === "17" || barcode.substring(16, 18) === "13")
        && barcode.substring(24, 26) === "10") {
        return Barcode.Stacked;

    } else if (barcode.substring(0, 5) == "01006") {
        return Barcode.GreenPreRole;

    } else {
        return Barcode.UPC;
    }
}

export const isToday = (dateString) => {
    const inputDate = new Date(dateString);
    const today = new Date();

    // Compare the input date with today's date
    return inputDate.getDate() === today.getDate() &&
           inputDate.getMonth() === today.getMonth() &&
           inputDate.getFullYear() === today.getFullYear();
}
